export interface ZoomPreset {
    normal: number;
    zoomIn: number;
    zoomOut: number;
}

export const ZOOM_TOLERANCE = 0.001;

export function getVisualViewportScale(): number {
    if (typeof window === 'undefined') {
        return 1;
    }

    return window.visualViewport?.scale ?? 1;
}

export function getEffectiveViewportWidth(): number {
    if (typeof window === 'undefined') {
        return 0;
    }

    const width = window.innerWidth || document.documentElement?.clientWidth || 0;
    const visualScale = getVisualViewportScale();

    if (Math.abs(visualScale - 1) > ZOOM_TOLERANCE) {
        return width * visualScale;
    }

    const outerWidth = window.outerWidth || 0;
    if (outerWidth && width) {
        const zoomFactor = outerWidth / width;
        if (Math.abs(zoomFactor - 1) > ZOOM_TOLERANCE) {
            return width * zoomFactor;
        }
    }

    return width;
}

export function getZoomPresetForWidth(effectiveWidth: number): ZoomPreset {
    if (effectiveWidth >= 1500) {
        return { normal: 1.15, zoomIn: 1.3, zoomOut: 0.95 };
    }

    if (effectiveWidth >= 1100) {
        return { normal: 0.75, zoomIn: 0.95, zoomOut: 0.5 };
    }

    return { normal: 1, zoomIn: 1.25, zoomOut: 0.8 };
}

export function resolveStoredZoom(rawZoom: string | null | undefined, preset: ZoomPreset): number {
    const parsed = rawZoom ? parseFloat(rawZoom) : NaN;
    if (!Number.isFinite(parsed)) {
        return preset.normal;
    }

    if (rawZoom === '1' && preset.normal !== 1) {
        return preset.normal;
    }

    const allowedValues = [preset.zoomOut, preset.normal, preset.zoomIn].sort((a, b) => a - b);

    const nearestValue = allowedValues.reduce((closest, candidate) => {
        const candidateDiff = Math.abs(candidate - parsed);
        const closestDiff = Math.abs(closest - parsed);
        return candidateDiff < closestDiff ? candidate : closest;
    });

    return nearestValue;
}
